module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-FACEBOOK.ca71b9b4.png";